import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  showText?: boolean;
}

export function Logo({ className, size = "md", showText = true }: LogoProps) {
  const sizes = {
    sm: { icon: "w-6 h-6", text: "text-lg", gap: "gap-2" },
    md: { icon: "w-8 h-8", text: "text-xl", gap: "gap-2.5" },
    lg: { icon: "w-12 h-12", text: "text-2xl", gap: "gap-3" },
  };

  return (
    <div className={cn("flex items-center", sizes[size].gap, className)}>
      {/* Custom String/Music Icon with Glow */}
      <div className="relative">
        <div className="absolute inset-0 bg-primary/40 blur-lg rounded-full animate-pulse" />
        <svg
          className={cn(sizes[size].icon, "relative z-10")}
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Outer ring with gradient */}
          <circle
            cx="20"
            cy="20"
            r="18"
            stroke="url(#logoGradient)"
            strokeWidth="2"
            fill="none"
          />
          
          {/* Inner decorative arcs - like violin strings */}
          <path
            d="M12 14 Q20 8 28 14"
            stroke="url(#logoGradient)"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M10 20 Q20 12 30 20"
            stroke="url(#logoGradient)"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
          />
          <path
            d="M12 26 Q20 20 28 26"
            stroke="url(#logoGradient)"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
          />
          
          {/* Center accent dot */}
          <circle cx="20" cy="20" r="3" fill="url(#logoGradient)" />
          
          {/* Gradient definitions */}
          <defs>
            <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="hsl(160, 84%, 49%)" />
              <stop offset="100%" stopColor="hsl(180, 100%, 50%)" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={cn(
            sizes[size].text,
            "font-bold tracking-tight bg-gradient-to-r from-primary via-primary-glow to-accent bg-clip-text text-transparent"
          )}>
            The Lost Strings
          </span>
        </div>
      )}
    </div>
  );
}
